export const CORE_ERRORS: { [key: string]: string } = {
    'http_401': 'Invalid credentials. Please check your input.',
    'http_500': 'The server returned an internal error. Please try again',
    'http_0': 'Server could not be reached. Please try again'
};
